import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IIndustriesState = {
  industries: []
};

const industriesReducer = (
  state: types.IIndustriesState = defaultState, 
  action: IAction | types.ISetIndustriesAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_INDUSTRIES: {
      return {...state, industries: (action as types.ISetIndustriesAction).industries};
    }    
    default: {
      return state;
    }
  }
};


export default industriesReducer;
